import { gql } from "@apollo/client";

// Define mutation
export const CREATE_EMPTY_CART = gql`
  mutation createCart {
    cartId: createEmptyCart
  }
`;

export const REMOVE_ALL_ITEMS_FROM_CART = gql`
  mutation removeAllItemFromCart($cartId: String!) {
    removeAllItemFromCart(input: { cart_id: $cartId }) {
      cart {
        id
        total_quantity
        __typename
      }
      __typename
    }
  }
`;

export const REMOVE_CART_ITEM = gql`
  mutation removeCartItem($cartId: String!, $cartItemUid: ID!) {
    removeItemFromCart(
      input: { cart_id: $cartId, cart_item_uid: $cartItemUid }
    ) {
      cart {
        id
        total_quantity
        __typename
      }
      __typename
    }
  }
`;

export const ADD_BUNDLE_ITEMS_TO_CART = gql`
  mutation addBundleItemsToCart(
    $cartId: String!
    $attorneySize: Int!
    $packageType: String!
    $subscriptionType: String!
    $sku: String!
    $bundleOptions: [BundleOptionInput]!
    $customizableOptions: [CustomizableOptionInput]!
    $subscriptionMonth: Int
    $subscriptionYear: Int
  ) {
    addBundleProductsToCart(
      input: {
        cart_id: $cartId
        ln_sl_jurisdiction: null
        ln_sl_noattorney: $attorneySize
        ln_sl_package_type: $packageType
        ln_sl_subscription_type: $subscriptionType
        ln_sl_subscription_year: $subscriptionYear
        ln_sl_subscription_month: $subscriptionMonth
        cart_items: [
          {
            data: { sku: $sku, quantity: 1 }
            bundle_options: $bundleOptions
            customizable_options: $customizableOptions
          }
        ]
      }
    ) {
      cart {
        id
        ...CartTriggerFragment
        ...MiniCartFragment
        ...BillingAddressFragment
        ...CustomAttributesFragment
        __typename
      }
      __typename
    }
  }

  fragment CartTriggerFragment on Cart {
    id
    total_quantity
    __typename
  }

  fragment MiniCartFragment on Cart {
    id
    total_quantity
    applied_coupon {
      code
      __typename
    }
    prices {
      discount {
        label
        amount {
          value
          __typename
        }
        __typename
      }
      subtotal_with_discount_excluding_tax {
        value
        __typename
      }
      subtotal_including_tax {
        value
        __typename
      }
      subtotal_excluding_tax {
        value
        __typename
      }
      applied_taxes {
        label
        amount {
          value
          currency
          __typename
        }
        __typename
      }
      grand_total {
        value
        currency
        __typename
      }
      __typename
    }
    ...ProductListFragment
    __typename
  }

  fragment ProductListFragment on Cart {
    id
    items {
      uid
      product {
        uid
        name
        url_key
        thumbnail {
          url
          __typename
        }
        stock_status
        ... on ConfigurableProduct {
          variants {
            attributes {
              uid
              __typename
            }
            product {
              uid
              thumbnail {
                url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      prices {
        price {
          currency
          value
          __typename
        }
        __typename
      }
      quantity
      ... on ConfigurableCartItem {
        configurable_options {
          configurable_product_option_uid
          option_label
          configurable_product_option_value_uid
          value_label
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }

  fragment BillingAddressFragment on Cart {
    id
    billing_address {
      firstname
      lastname
      company
      street
      city
      region {
        code
        label
        __typename
      }
      postcode
      telephone
      country {
        code
        label
        __typename
      }
      __typename
    }
    __typename
  }

  fragment CustomAttributesFragment on Cart {
    id
    total_quantity
    custom_attributes {
      ln_sl_package_type
      ln_sl_noattorney
      ln_sl_subscription_type
      ln_sl_subscription_year
      ln_sl_subscription_month
      __typename
    }
    __typename
  }
`;

export const ADD_VIRTUAL_ITEMS_TO_CART = gql`
  mutation addVirtualItemsToCart(
    $cartId: String!
    $attorneySize: Int!
    $packageType: String!
    $subscriptionType: String!
    $cartItems: [VirtualProductCartItemInput]!
    $subscriptionMonth: Int
    $subscriptionYear: Int
  ) {
    addVirtualProductsToCart(
      input: {
        cart_id: $cartId
        ln_sl_jurisdiction: null
        ln_sl_noattorney: $attorneySize
        ln_sl_package_type: $packageType
        ln_sl_subscription_type: $subscriptionType
        ln_sl_subscription_year: $subscriptionYear
        ln_sl_subscription_month: $subscriptionMonth
        cart_items: $cartItems
      }
    ) {
      cart {
        id
        ...CartTriggerFragment
        ...MiniCartFragment
        ...BillingAddressFragment
        ...CustomAttributesFragment
        __typename
      }
      __typename
    }
  }

  fragment CartTriggerFragment on Cart {
    id
    total_quantity
    __typename
  }

  fragment MiniCartFragment on Cart {
    id
    total_quantity
    applied_coupon {
      code
      __typename
    }
    prices {
      discount {
        label
        amount {
          value
          __typename
        }
        __typename
      }
      subtotal_with_discount_excluding_tax {
        value
        __typename
      }
      subtotal_including_tax {
        value
        __typename
      }
      subtotal_excluding_tax {
        value
        __typename
      }
      applied_taxes {
        label
        amount {
          value
          currency
          __typename
        }
        __typename
      }
      grand_total {
        value
        currency
        __typename
      }
      __typename
    }
    ...ProductListFragment
    __typename
  }

  fragment ProductListFragment on Cart {
    id
    items {
      uid
      product {
        uid
        name
        url_key
        thumbnail {
          url
          __typename
        }
        stock_status
        ... on ConfigurableProduct {
          variants {
            attributes {
              uid
              __typename
            }
            product {
              uid
              thumbnail {
                url
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      prices {
        price {
          currency
          value
          __typename
        }
        __typename
      }
      quantity
      ... on ConfigurableCartItem {
        configurable_options {
          configurable_product_option_uid
          option_label
          configurable_product_option_value_uid
          value_label
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }

  fragment BillingAddressFragment on Cart {
    id
    billing_address {
      firstname
      lastname
      company
      street
      city
      region {
        code
        label
        __typename
      }
      postcode
      telephone
      country {
        code
        label
        __typename
      }
      __typename
    }
    __typename
  }

  fragment CustomAttributesFragment on Cart {
    id
    total_quantity
    custom_attributes {
      ln_sl_package_type
      ln_sl_noattorney
      ln_sl_subscription_type
      ln_sl_subscription_year
      ln_sl_subscription_month
      __typename
    }
    __typename
  }
`;

export const SET_BILLING_ADDRESS_ON_CART = gql`
  mutation SetBillingAddressOnCart(
    $cartId: String!
    $firstname: String!
    $lastname: String!
    $telephone: String
    $jobTitle: String!
    $company: String!
    $street: [String]!
    $city: String!
    $region: String!
    $postcode: String!
    $lnFe: [FeeEarnerInput]!
    $country_code: String!
  ) {
    setBillingAddressOnCart(
      input: {
        cart_id: $cartId
        ln_abn: ""
        ln_fe: $lnFe
        ln_job_title: $jobTitle
        billing_address: {
          address: {
            firstname: $firstname
            lastname: $lastname
            company: $company
            street: $street
            city: $city
            region: $region
            postcode: $postcode
            country_code: $country_code
            telephone: $telephone
            save_in_address_book: true
          }
          same_as_shipping: false
        }
      }
    ) {
      cart {
        billing_address {
          firstname
          lastname
          company
          street
          city
          region {
            code
            label
            __typename
          }
          postcode
          telephone
          country {
            code
            label
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const SET_EMAIL_ON_CART = gql`
  mutation setEmailOnCart($cart_id: String!, $email: String!) {
    setGuestEmailOnCart(input: { cart_id: $cart_id, email: $email }) {
      cart {
        email
        __typename
      }
      __typename
    }
  }
`;

export const APPLY_COUPON_TO_CART = gql`
  mutation ApplyCouponToCart($cart_id: String!, $couponCode: String!) {
    applyCouponToCart(input: { cart_id: $cart_id, coupon_code: $couponCode }) {
      cart {
        etax_api_is_success
        applied_coupon {
          code
          __typename
        }
        prices {
          discount {
            label
            amount {
              value
              __typename
            }
            __typename
          }
          subtotal_with_discount_excluding_tax {
            value
            __typename
          }
          subtotal_including_tax {
            value
            __typename
          }
          subtotal_excluding_tax {
            value
            __typename
          }
          applied_taxes {
            label
            amount {
              value
              currency
              __typename
            }
            __typename
          }
          grand_total {
            value
            currency
            __typename
          }
          __typename
        }
        billing_address {
          firstname
          lastname
          company
          street
          city
          region {
            region_id
            code
            label
            __typename
          }
          postcode
          telephone
          country {
            code
            label
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;

export const REMOVE_COUPON_CODE = gql`
  mutation removeCouponFromCart($cart_id: String!) {
    removeCouponFromCart(input: { cart_id: $cart_id }) {
      cart {
        applied_coupons {
          code
        }
        prices {
          discounts {
            label
            amount {
              value
              __typename
            }
            __typename
          }
          subtotal_with_discount_excluding_tax {
            value
            __typename
          }
          subtotal_including_tax {
            value
            __typename
          }
          subtotal_excluding_tax {
            value
            __typename
          }
          applied_taxes {
            label
            amount {
              value
              currency
              __typename
            }
            __typename
          }
          grand_total {
            value
            currency
            __typename
          }
          __typename
        }
      }
    }
  }
`;
